import Echo from "laravel-echo"
import Pusher from "pusher-js"

window.Pusher = Pusher

let echo = null
const createEcho = () => {
  const token = localStorage.getItem("token")

  return new Echo({
    broadcaster: "pusher",
    key: "4415ffb843e0443e82f9",
    cluster: "mt1",
    forceTLS: true,

    authEndpoint: "https://admin.afrimedsolutions.cloud/api/broadcasting/auth-manual",

    auth: {
      headers: {
        Authorization: token ? `Bearer ${token}` : "",
        Accept: "application/json",
      },
    },

    enabledTransports: ["ws", "wss"],
    disableStats: true,
  })
}

const bindConnectionEvents = () => {
  if (!echo || !echo.connector?.pusher) return

  const pusher = echo.connector.pusher

  pusher.connection.bind("connected", () => {
    // console.info("Echo connected")
  })

  pusher.connection.bind("disconnected", () => {
    // console.warn("Echo disconnected")
  })

  pusher.connection.bind("error", () => {
    // console.error("Echo error", error)
  })

  pusher.connection.bind("state_change", () => {
    // console.log(`Echo state: ${states.previous} → ${states.current}`)
  })
}

const initEcho = () => {
  if (!echo) {
    echo = createEcho()
    bindConnectionEvents()
  }
  return echo
}

export const reconnectEcho = () => {
  if (!echo) return

  echo.disconnect()
  echo = createEcho()
  bindConnectionEvents()
}

window.addEventListener("online", () => {
  reconnectEcho()
})

window.addEventListener("offline", () => {
  // console.info("Network offline")
})
export default initEcho()
